import { hasPermissionTo } from "common/functions/roles";
import { isQueryValid } from "common/query-builder/validation";
import { getRulesValidator } from "common/query/filter";
import { getPathMap } from "common/query/joins";
import {
  FilterRule,
  isExpressionRule,
  isSelectField,
} from "common/query/types";
import { Context } from "common/types/context";
import { Action } from "common/types/roles";
import { SchedulerFilter } from "common/types/scheduler-filters";

export const isSelectValid = (context: Context, filter: SchedulerFilter) => {
  const pathMap = getPathMap(context?.entities, filter);

  return !!filter?.query?.select?.every((select) => {
    if (!isSelectField(select)) return true;

    const entity = pathMap[select.path ?? ""];

    return entity?.columns?.some((column) => column.name === select.name);
  });
};

export const isFilterValid = (
  context: Context,
  schedulerFilter: SchedulerFilter,
) => {
  const pathMap = getPathMap(context?.entities, schedulerFilter);

  const validate = getRulesValidator((rule: FilterRule) => {
    if (!rule) return true;
    if (isExpressionRule(rule)) return true;

    const entity = pathMap[rule.path ?? ""];

    return !!entity?.columns?.some((column) => column.name === rule.name);
  });

  return validate(schedulerFilter?.query?.filter);
};

export const getSchedulerFiltersPermissions = (
  context: Context,
  actions: Action[] = [],
) => {
  const { userTypes, role } = context;
  return actions.reduce((acc: any, action: Action) => {
    const actionKey = `can${action}`;
    return {
      ...acc,
      [actionKey]: hasPermissionTo(userTypes, role, "SchedulerFilters", action),
    };
  }, {});
};

export function isSchedulerFilterValid(
  context: Context,
  filter: SchedulerFilter,
) {
  if (!filter) return true;

  return (
    isSelectValid(context, filter) &&
    isFilterValid(context, filter) &&
    isQueryValid(context.entities, {
      entity: filter.entity,
      query: filter.query,
    })
  );
}
